import { take, put } from 'redux-saga/effects';
import { loginFinished } from 'features/room/roomSlice';
import { signalingConnected } from 'features/application/actions';

export function* loginRoomSaga() {
  yield take(signalingConnected);

  yield put(loginFinished());
}
